<template>
  <div>
    <SectionHeader>
      <template v-slot:breadcrumbs>
        <BreadCrumbs :items="[{ text: $t('containers.containers'), name: 'containers' }, { text: container.name }]" />
      </template>
      <template v-slot:meta>
        <Link
          v-if="container.company"
          :to="`/company/containers/${container.uuid}`"
          class="button button-green button-round button-small"
          >{{ $t('containers.editContainer') }}</Link
        >
      </template>
    </SectionHeader>

    <LoadingSpinner v-if="loading" />
    <Container v-else :containerUuid="containerUuid" />
  </div>
</template>

<script>
import BreadCrumbs from '@/components/BreadCrumbs'
import LoadingSpinner from '@/components/LoadingSpinner'
import SectionHeader from '@/components/SectionHeader'
import Container from '@/components/container'

import containersApi from '@/api/container'

export default {
  name: 'container_details',
  components: {
    BreadCrumbs,
    Container,
    LoadingSpinner,
    SectionHeader,
  },
  data() {
    return {
      loading: true,
      containerUuid: '',
      container: {},
    }
  },
  methods: {
    async getContainer() {
      this.container = await containersApi.get(this.$route.params.uuid)
    },
  },
  async mounted() {
    await this.getContainer()
    this.containerUuid = this.$route.params.uuid
    this.loading = false
  },
}
</script>
